import React from 'react'
import Layout from '../../components/auth/layout'
import LockForm from '../../components/auth/lock'
import { v1_unlock } from '../../actions/v1/auth'
import { setStorage } from '../../utils'
import constant from '../../constant'
import swal from 'sweetalert';

const Login = (props) => {
    const onUnlock = (model) => {
        v1_unlock(model).then(res => {
            if (res.status) {
                setStorage(constant.keys.userToken, res.result.token);
                props.history.push(constant.Authedcomponent.dashboard.url)
            }
            else {
                swal({
                    title: res.error.message,
                    icon: "warning",
                    dangerMode: true,
                })
            }
        })
    }
    return (
        <React.Fragment>
            <Layout>
                <LockForm
                    onSubmit={onUnlock}
                />
            </Layout>
        </React.Fragment>)
}

export default Login